
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Questions extends Vue {
  @Prop(Array) Preguntas!: any;
  @Prop(Function) next!: any;
  currentIndex: number = 0;

  backStep() {
    (this as any).currentIndex = (this as any).currentIndex - 1;
  }

  nextStep() {
    const _this: any = this;
    if (_this.Preguntas.length === _this.currentIndex + 1) {
      _this.next();
    } else if (_this.Preguntas[_this.currentIndex].answer) {
      _this.currentIndex = _this.currentIndex + 1;
    }
  }
}
